<template>
  <TWModal
    :show="true"
    :title="colourType === 'primary' ? $t('branding.primaryColour') : $t('branding.secondaryColour')"
    :loading="loading"
    @close="handleClose"
  >
    <template slot="content">
      <h4 class="!font-body">
        {{ $t('branding.selectBrandColour', { type: colourType }) }}
      </h4>
      <ElColorPicker
        class="block my-base"
        popperClass="hideClearButton"
        size="large"
        v-model="colour"
        data-ec="branding_colour_modal"
        data-et="colour_picker"
      />

      <h4 class="!font-body">{{ $t('functional.preview') }}</h4>
      <div
        class="flex justify-center items-center w-48 aspect-16/9 my-base rounded-lg"
        :style="{ 'background-color': colour }"
      >
        <span
          class="text-white font-semibold"
          :class="{ 'text-black': colourIsLight }"
        >
          {{ colour }}
        </span>
      </div>
    </template>

    <template slot="controls">
      <BaseButton
        @click.native="handleClose"
        variant="invisible"
        data-ec="branding_colour_modal"
        data-et="cancel_button"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        :disabled="!colour"
        @click.native="handleSave"
        data-ec="branding_colour_modal"
        data-et="save_button"
      >
        {{ $t('functional.save') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script setup>
// @ts-check
import { ref } from 'vue';

import { useLightOrDark } from '@/composables/utils/colour/useContrastColour';

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import TWModal from '@/components/tailwind/Modal.vue';

const props = defineProps({
  /** @type {import('vue').PropOptions<'primary' | 'secondary'>} */
  colourType: {
    required: false,
    default: 'primary',
  },
  /** @type {import('vue').PropOptions<import('@/composables/utils/colour/useContrastColour').Hex | null>} */
  initialColour: {
    required: false,
  },
  /** @type {import('vue').PropOptions<(update: string|null) => Promise<void>>} */
  update: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(['close']);

const loading = ref(false);
const colour = ref(props.initialColour);

const colourIsLight = useLightOrDark(colour);

function handleClose() {
  emit('close');
}
async function handleSave() {
  loading.value = true;

  try {
    await props.update(colour.value);
    emit('close');
  } finally {
    loading.value = false;
  }
}
</script>

<style>
/* clearing the colour doesn't make sense for this use case so hiding the button */
.hideClearButton.el-color-picker__panel .el-color-dropdown__link-btn {
  display: none;
}
</style>
